<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- Main Card -->
    <v-card class="main-card" flat>
      <!-- Tabs -->
      <v-tabs v-model="tabs" background-color="transparent" centered grow show-arrows slider-color="transparent"
        class="custom-tabs">
        <v-tab :class="['custom-tab', 'first-tab', { 'active-tab': tabs === 0 }]"
          v-if="profile_relative_tab.indexOf('Under_guardian_tab_guardian_details') !== -1">
          <v-icon class="mr-2">mdi-account</v-icon>Guardian Details
        </v-tab>
        <v-tab :class="['custom-tab', { 'active-tab': tabs === 1 }]"
          v-if="profile_relative_tab.indexOf('Under_guardian_tab_emergency_contact_details') !== -1">
          <v-icon class="mr-2">mdi-human-male-female-child</v-icon>Emergency Contact Details
        </v-tab>
      </v-tabs>

      <!-- Tabs Content -->
      <v-tabs-items v-model="tabs">
        <!-- Guardian Tab -->
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_guardian_tab_guardian_details') !== -1">
          <v-card>
            <!-- Guardian 1 Details -->
            <v-toolbar class="custom-toolbar ma-2" flat dense>
              <v-toolbar-title>Guardian1 Details</v-toolbar-title>
            </v-toolbar>

            <v-row dense class="px-5">
              <v-col v-for="field in guardianDetails.guardian1.fields" :key="field.field_name"
                v-if="field.isactive && field.input_type !== 'file'" cols="12" sm="3">
                <div class="pl-1 pb-2" style="font-size: 14px;">
                  <b>{{ field.label }}</b><v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                </div>
                <!-- Text Field -->
                <v-text-field v-if="field.input_type === 'text' && !field.field_name.includes('address')"
                  v-model.trim="field.value" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded
                  dense @keypress="blockNonLetters" />
                <!-- Number Field -->
                <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value" type="tel"
                  :rules="getNumberFieldRules(field.field_name, field.required)" :readonly="!field.iseditable"
                  :filled="!field.iseditable" outlined rounded dense maxlength="12" @keypress="onlyDigits" />
                <!-- Email Field -->
                <v-text-field v-if="field.input_type === 'email'" v-model.trim="field.value" :rules="emailRules"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
                <!-- Select Field -->
                <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="field.value"
                  :items="field.options" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded
                  dense />
                <!-- Multiple Select Field -->
                <v-autocomplete v-if="field.input_type === 'select' && field.multiple" v-model="field.value"
                  :items="field.options" :multiple="true" :readonly="!field.iseditable" :filled="!field.iseditable"
                  :clearable="true" dense single-line rounded outlined />
                <!-- Textarea for Address -->
                <v-textarea v-if="field.field_name.includes('address')" v-model.trim="field.value"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
              </v-col>
              <!-- Save Button -->
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian1" @click="SaveGuardiandata('Guardian1')" text
                  class="button-77">Save</v-btn>
              </v-col>
            </v-row>

            <!-- Guardian 1 Photo Upload -->
            <v-toolbar class="custom-toolbar ma-2 mt-4" flat dense>
              <v-toolbar-title>Guardian1 Photo</v-toolbar-title>
            </v-toolbar>
            <v-row v-if="guardianDetails.guardian1.fields.some(f => f.field_name === 'guardian1_photo' && f.isactive)">
              <v-col cols="12" sm="5" class="pl-7">
                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                  <b class="pl-6">Photo Upload Instructions:</b>
                  <ul>
                    <li>Photo should be in .jpg/.png format only.</li>
                    <li>Image resolution must not exceed 350x450 pixels.</li>
                    <li>Size ≤ 500KB.</li>
                  </ul>
                </div>
                <div class="pt-4">
                  <span class="pl-8"><b>Guardian1 Photo</b></span>
                  <v-icon v-if="guardianDetails.guardian1.fields.find(f => f.field_name === 'guardian1_photo').required"
                    class="pl-1 pb-2" color="error">*</v-icon>
                  <v-file-input v-model="guardianDetails.guardian1.photo" prepend-icon="mdi-camera" show-size outlined
                    accept="image/jpeg, image/png" :error-messages="[photoValidationError]" @change="guardian_photo1" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" class="pl-10">
                <span><b>Selected Photo</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img v-if="previewguardian1Photo" :src="previewguardian1Photo" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" v-if="guardianDetails.guardian1.old_photo" class="pl-10">
                <span><b>Previous Photo</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img :src="awspath + guardianDetails.guardian1.old_photo" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian1_photo" @click="SaveGuardiandata('Guardian1_Photo')" text
                  class="button-77">Upload Photo</v-btn>
              </v-col>
            </v-row>

            <!-- Guardian 1 Signature Upload -->
            <v-toolbar class="custom-toolbar ma-2 mt-4" flat dense>
              <v-toolbar-title>Guardian1 Signature</v-toolbar-title>
            </v-toolbar>
            <v-row
              v-if="guardianDetails.guardian1.fields.some(f => f.field_name === 'guardian1_signature' && f.isactive)">
              <v-col cols="12" sm="5" class="pl-7">
                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                  <b class="pl-6">Signature Upload Instructions:</b>
                  <ul>
                    <li>Signature should be in .jpg/.png format only.</li>
                    <li>Image resolution must not exceed 350x450 pixels.</li>
                    <li>Size ≤ 500KB.</li>
                  </ul>
                </div>
                <div class="pt-4">
                  <span class="pl-8"><b>Guardian1 Signature</b></span>
                  <v-icon
                    v-if="guardianDetails.guardian1.fields.find(f => f.field_name === 'guardian1_signature').required"
                    class="pl-1 pb-2" color="error">*</v-icon>
                  <v-file-input v-model="guardianDetails.guardian1.signature" prepend-icon="mdi-pen" show-size outlined
                    accept="image/jpeg, image/png" :error-messages="[signatureValidationError]"
                    @change="validateSignature" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" class="pl-10">
                <span><b>Selected Signature</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img v-if="previewSignature" :src="previewSignature" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" v-if="guardianDetails.guardian1.old_signature" class="pl-10">
                <span><b>Previous Signature</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img :src="awspath + guardianDetails.guardian1.old_signature" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian1_signature" @click="SaveGuardiandata('Guardian1_Signature')" text
                  class="button-77">Upload Signature</v-btn>
              </v-col>
            </v-row>

            <!-- Guardian 2 Details -->
            <v-toolbar class="custom-toolbar ma-2 mt-4" flat dense>
              <v-toolbar-title>Guardian2 Details</v-toolbar-title>
            </v-toolbar>
            <v-row dense class="px-5">
              <v-col v-for="field in guardianDetails.guardian2.fields" :key="field.field_name"
                v-if="field.isactive && field.input_type !== 'file'" cols="12" sm="3">
                <div class="pl-1 pb-2" style="font-size: 14px;">
                  <b>{{ field.label }}</b><v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                </div>
                <!-- Text Field -->
                <v-text-field v-if="field.input_type === 'text' && !field.field_name.includes('address')"
                  v-model.trim="field.value" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded
                  dense
                  @keypress="blockNonLetters"/>
                <!-- Number Field -->
                <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value" type="tel"
                  :rules="getNumberFieldRules(field.field_name, field.required)" :readonly="!field.iseditable"
                  :filled="!field.iseditable" outlined rounded dense maxlength="12" @keypress="onlyDigits" />
                <!-- Email Field -->
                <v-text-field v-if="field.input_type === 'email'" v-model.trim="field.value" :rules="emailRules"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
                <!-- Select Field -->
                <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="field.value"
                  :items="field.options" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded
                  dense />
                <!-- Multiple Select Field -->
                <v-autocomplete v-if="field.input_type === 'select' && field.multiple" v-model="field.value"
                  :items="field.options" :multiple="true" :readonly="!field.iseditable" :filled="!field.iseditable"
                  :clearable="true" dense single-line rounded outlined />
                <!-- Textarea for Address -->
                <v-textarea v-if="field.field_name.includes('address')" v-model.trim="field.value"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
              </v-col>
              <!-- Save Button -->
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian2" @click="SaveGuardiandata('Guardian2')" text
                  class="button-77">Save</v-btn>
              </v-col>
            </v-row>

            <!-- Guardian 2 Photo Upload -->
            <v-toolbar class="custom-toolbar ma-2 mt-4" flat dense>
              <v-toolbar-title>Guardian2 Photo</v-toolbar-title>
            </v-toolbar>
            <v-row v-if="guardianDetails.guardian2.fields.some(f => f.field_name === 'guardian2_photo' && f.isactive)">
              <v-col cols="12" sm="5" class="pl-7">
                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                  <b class="pl-6">Photo Upload Instructions:</b>
                  <ul>
                    <li>Photo should be in .jpg/.png format only.</li>
                    <li>Image resolution must not exceed 350x450 pixels.</li>
                    <li>Size ≤ 500KB.</li>
                  </ul>
                </div>
                <div class="pt-4">
                  <span class="pl-8"><b>Guardian2 Photo</b></span>
                  <v-icon v-if="guardianDetails.guardian2.fields.find(f => f.field_name === 'guardian2_photo').required"
                    class="pl-1 pb-2" color="error">*</v-icon>
                  <v-file-input v-model="guardianDetails.guardian2.photo" prepend-icon="mdi-camera" show-size outlined
                    accept="image/jpeg, image/png" :error-messages="[photoValidationError]" @change="guardian_photo2" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" class="pl-10">
                <span><b>Selected Photo</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img v-if="previewguardian2Photo" :src="previewguardian2Photo" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" v-if="guardianDetails.guardian2.old_photo" class="pl-10">
                <span><b>Previous Photo</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img :src="awspath + guardianDetails.guardian2.old_photo" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian2_photo" @click="SaveGuardiandata('Guardian2_Photo')" text
                  class="button-77">Upload Photo</v-btn>
              </v-col>
            </v-row>

            <!-- Guardian 2 Signature Upload -->
            <v-toolbar class="custom-toolbar ma-2 mt-4" flat dense>
              <v-toolbar-title>Guardian2 Signature</v-toolbar-title>
            </v-toolbar>
            <v-row
              v-if="guardianDetails.guardian2.fields.some(f => f.field_name === 'guardian2_signature' && f.isactive)">
              <v-col cols="12" sm="5" class="pl-7">
                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                  <b class="pl-6">Signature Upload Instructions:</b>
                  <ul>
                    <li>Signature should be in .jpg/.png format only.</li>
                    <li>Image resolution must not exceed 350x450 pixels.</li>
                    <li>Size ≤ 500KB.</li>
                  </ul>
                </div>
                <div class="pt-4">
                  <span class="pl-8"><b>Guardian2 Signature</b></span>
                  <v-icon
                    v-if="guardianDetails.guardian2.fields.find(f => f.field_name === 'guardian2_signature').required"
                    class="pl-1 pb-2" color="error">*</v-icon>
                  <v-file-input v-model="guardianDetails.guardian2.signature" prepend-icon="mdi-pen" show-size outlined
                    accept="image/jpeg, image/png" :error-messages="[signatureValidationError2]"
                    @change="validateSignature2" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" class="pl-10">
                <span><b>Selected Signature</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img v-if="previewSignature2" :src="previewSignature2" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" sm="3" v-if="guardianDetails.guardian2.old_signature" class="pl-10">
                <span><b>Previous Signature</b></span>
                <div style="border: 1px solid black; width: 180px; height: 180px;">
                  <img :src="awspath + guardianDetails.guardian2.old_signature" width="180" height="180" />
                </div>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_guardian2_signature" @click="SaveGuardiandata('Guardian2_Signature')" text
                  class="button-77">Upload Signature</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>

        <!-- Emergency Tab -->
        <!-- <v-tab-item v-if="profile_relative_tab.indexOf('Under_guardian_tab_emergency_contact_details') !== -1">
          <v-card class="pa-10">Emergency Contact Details Coming Soon...</v-card>
        </v-tab-item>
      </v-tabs-items> -->
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_guardian_tab_emergency_contact_details') !== -1">
          <v-card class="pa-10">
            <v-toolbar class="custom-toolbar ma-2" flat dense>
              <v-toolbar-title>Emergency Contact Details</v-toolbar-title>
            </v-toolbar>

            <v-row dense class="px-5">
              <v-col v-for="field in emergencyContactDetails.fields" :key="field.field_name"
                v-if="field.isactive && field.input_type !== 'file'" cols="12" sm="3">
                <div class="pl-1 pb-2" style="font-size: 14px;">
                  <b>{{ field.label }}</b><v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                </div>
                <!-- Text Field -->
                <!-- <v-text-field v-if="field.input_type === 'text' && !field.field_name.includes('address')"
            v-model.trim="field.value" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense
            @keypress="field.field_name.includes('name') ? blockNonLetters : null" /> -->
                <v-text-field v-if="field.input_type === 'text' && !field.field_name.includes('address')"
                  v-model.trim="field.value" :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded
                  dense :rules="field.field_name === 'emergency_contact_name' ? nameRules : []"
                  @keypress="field.field_name === 'emergency_contact_name' ? blockNonLetters : null" />
                <!-- Number Field -->
                <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value" type="tel"
                  :rules="getNumberFieldRules(field.field_name, field.required)" :readonly="!field.iseditable"
                  :filled="!field.iseditable" outlined rounded dense maxlength="10" @keypress="onlyDigits" />
                <!-- Select Field -->
                <v-select v-if="field.input_type === 'select'" v-model="field.value" :items="field.options"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
                <!-- Textarea for Address -->
                <v-textarea v-if="field.field_name.includes('address')" v-model.trim="field.value"
                  :readonly="!field.iseditable" :filled="!field.iseditable" outlined rounded dense />
              </v-col>
              <v-col cols="12" align="center">
                <v-btn :loading="save_loader_emergency" @click="saveEmergencyContactData" text
                  class="button-77">Save</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    props: {
      learner: {
        type: [String, Number],
        required: true
      },
      profile_relative_tab: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        tabs: 0,
        awspath: null,
        snackbar: false,
        color: "",
        snackbar_msg: "",
        save_loader_guardian1: false,
        save_loader_guardian1_photo: false,
        save_loader_guardian1_signature: false,
        save_loader_guardian2: false,
        save_loader_guardian2_photo: false,
        save_loader_guardian2_signature: false,
        save_loader_emergency: false, // New loader for emergency contact
        emergencyContactDetails: {
          present: false,
          fields: []
        },
        photoValidationError: '',
        signatureValidationError: '',
        signatureValidationError2: '',
        previewguardian1Photo: '',
        previewguardian2Photo: '',
        previewSignature: '',
        previewSignature2: '',
        emailRules: [
          v => !!v || 'Email is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ],
        nameRules: [
          v => !!v || 'Name is required',
          v => /^[a-zA-Z\s]*$/.test(v) || 'Name must contain only letters and spaces'
        ],
        guardianDetails: {
          learner_id: '',
          registration_number: '',
          guardian1: {
            present: false,
            fields: [],
            photo: null,
            signature: null,
            old_photo: null,
            old_signature: null
          },
          guardian2: {
            present: false,
            fields: [],
            photo: null,
            signature: null,
            old_photo: null,
            old_signature: null
          }
        }
      };
    },
    watch: {
      learner(newVal) {
        if (newVal) {
          this.getChildDataForPhofile();
        }
      }
    },
    mounted() {
      this.learner = localStorage.getItem("learner_for_profile");
      this.awspath = localStorage.getItem("awspath");
      if (this.learner) {
        this.getChildDataForPhofile();
      }
    },
    methods: {
      blockNonLetters(e) {
        const char = String.fromCharCode(e.keyCode);
        const pattern = /^[A-Za-z ]+$/; // letters + space

        if (!pattern.test(char)) {
          e.preventDefault(); // block digit + special chars
        }
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      resetLoaders() {
        this.save_loader_guardian1 = false;
        this.save_loader_guardian1_photo = false;
        this.save_loader_guardian1_signature = false;
        this.save_loader_guardian2 = false;
        this.save_loader_guardian2_photo = false;
        this.save_loader_guardian2_signature = false;
        this.save_loader_emergency = false;
      },
      onlyDigits(e) {
        const char = String.fromCharCode(e.keyCode || e.which);
        if (!/[0-9]/.test(char)) e.preventDefault();
      },
      blockNonLetters(e) {
        const char = String.fromCharCode(e.keyCode || e.which);
        if (!/^[a-zA-Z\s]$/.test(char)) e.preventDefault();
      },
      getNumberFieldRules(fieldName, isRequired) {
        const rules = [];
        if (isRequired) {
          rules.push(v => !!v || `${fieldName.replace(/_/g, ' ')} is required`);
        }
        if (fieldName.includes('aadhar_no')) {
          rules.push(v => !v || v.toString().length === 12 || `${fieldName.replace(/_/g, ' ')} must be exactly 12 digits`);
          rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
        }
        if (fieldName.includes('contact') || fieldName.includes('office_no')) {
          rules.push(v => !v || v.toString().length === 10 || `${fieldName.replace(/_/g, ' ')} must be exactly 10 digits`);
          rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
        }
        if (fieldName.includes('emergency_contact_number')) {
          rules.push(v => !v || v.toString().length === 10 || `${fieldName.replace(/_/g, ' ')} must be exactly 10 digits`);
          rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
        }
        return rules;
      },
      // guardian_photo1(file) {
      //   this.photoValidationError = '';
      //   this.previewguardian1Photo = '';
      //   if (!file) return;

      //   const allowedTypes = ['image/jpeg', 'image/png'];
      //   const maxSize = 500 * 1024;

      //   if (!allowedTypes.includes(file.type)) {
      //     this.photoValidationError = 'Only JPG and PNG formats are allowed.';
      //     this.guardianDetails.guardian1.photo = null;
      //     return;
      //   }
      //   if (file.size > maxSize) {
      //     this.photoValidationError = 'File size should be 500KB or less.';
      //     this.guardianDetails.guardian1.photo = null;
      //     return;
      //   }

      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     const img = new Image();
      //     img.onload = () => {
      //       if (img.width !== 350 || img.height !== 450) {
      //         this.photoValidationError = 'Image resolution must be 350x450 pixels.';
      //         this.guardianDetails.guardian1.photo = null;
      //       } else {
      //         this.previewguardian1Photo = e.target.result;
      //       }
      //     };
      //     img.src = e.target.result;
      //   };
      //   reader.readAsDataURL(file);
      // },
      // guardian_photo2(file) {
      //   this.photoValidationError = '';
      //   this.previewguardian2Photo = '';
      //   if (!file) return;

      //   const allowedTypes = ['image/jpeg', 'image/png'];
      //   const maxSize = 500 * 1024;

      //   if (!allowedTypes.includes(file.type)) {
      //     this.photoValidationError = 'Only JPG and PNG formats are allowed.';
      //     this.guardianDetails.guardian2.photo = null;
      //     return;
      //   }
      //   if (file.size > maxSize) {
      //     this.photoValidationError = 'File size should be 500KB or less.';
      //     this.guardianDetails.guardian2.photo = null;
      //     return;
      //   }

      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     const img = new Image();
      //     img.onload = () => {
      //       if (img.width !== 350 || img.height !== 450) {
      //         this.photoValidationError = 'Image resolution must be 350x450 pixels.';
      //         this.guardianDetails.guardian2.photo = null;
      //       } else {
      //         this.previewguardian2Photo = e.target.result;
      //       }
      //     };
      //     img.src = e.target.result;
      //   };
      //   reader.readAsDataURL(file);
      // },
      // validateSignature(file) {
      //   this.signatureValidationError = '';
      //   this.previewSignature = '';
      //   if (!file) return;

      //   const allowedTypes = ['image/jpeg', 'image/png'];
      //   const maxSize = 500 * 1024;

      //   if (!allowedTypes.includes(file.type)) {
      //     this.signatureValidationError = 'Only JPG and PNG formats are allowed.';
      //     this.guardianDetails.guardian1.signature = null;
      //     return;
      //   }
      //   if (file.size > maxSize) {
      //     this.signatureValidationError = 'File size should be 500KB or less.';
      //     this.guardianDetails.guardian1.signature = null;
      //     return;
      //   }

      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     const img = new Image();
      //     img.onload = () => {
      //       if (img.width !== 350 || img.height !== 450) {
      //         this.signatureValidationError = 'Signature resolution must be 350x450 pixels.';
      //         this.guardianDetails.guardian1.signature = null;
      //       } else {
      //         this.previewSignature = e.target.result;
      //       }
      //     };
      //     img.src = e.target.result;
      //   };
      //   reader.readAsDataURL(file);
      // },
      // validateSignature2(file) {
      //   this.signatureValidationError2 = '';
      //   this.previewSignature2 = '';
      //   if (!file) return;

      //   const allowedTypes = ['image/jpeg', 'image/png'];
      //   const maxSize = 500 * 1024;

      //   if (!allowedTypes.includes(file.type)) {
      //     this.signatureValidationError2 = 'Only JPG and PNG formats are allowed.';
      //     this.guardianDetails.guardian2.signature = null;
      //     return;
      //   }
      //   if (file.size > maxSize) {
      //     this.signatureValidationError2 = 'File size should be 500KB or less.';
      //     this.guardianDetails.guardian2.signature = null;
      //     return;
      //   }

      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     const img = new Image();
      //     img.onload = () => {
      //       if (img.width !== 350 || img.height !== 450) {
      //         this.signatureValidationError2 = 'Signature resolution must be 350x450 pixels.';
      //         this.guardianDetails.guardian2.signature = null;
      //       } else {
      //         this.previewSignature2 = e.target.result;
      //       }
      //     };
      //     img.src = e.target.result;
      //   };
      //   reader.readAsDataURL(file);
      // },
      guardian_photo1(file) {
        this.photoValidationError = '';
        this.previewguardian1Photo = '';
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSize = 500 * 1024;
        const maxWidth = 350;
        const maxHeight = 450;

        if (!allowedTypes.includes(file.type)) {
          this.photoValidationError = 'Only JPG and PNG formats are allowed.';
          this.guardianDetails.guardian1.photo = null;
          return;
        }
        if (file.size > maxSize) {
          this.photoValidationError = 'File size should be 500KB or less.';
          this.guardianDetails.guardian1.photo = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > maxWidth || img.height > maxHeight) {
              this.photoValidationError = `Image resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
              this.guardianDetails.guardian1.photo = null;
            } else {
              this.previewguardian1Photo = e.target.result;
              this.guardianDetails.guardian1.photo = file;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      guardian_photo2(file) {
        this.photoValidationError = '';
        this.previewguardian2Photo = '';
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSize = 500 * 1024;
        const maxWidth = 350;
        const maxHeight = 450;

        if (!allowedTypes.includes(file.type)) {
          this.photoValidationError = 'Only JPG and PNG formats are allowed.';
          this.guardianDetails.guardian2.photo = null;
          return;
        }
        if (file.size > maxSize) {
          this.photoValidationError = 'File size should be 500KB or less.';
          this.guardianDetails.guardian2.photo = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > maxWidth || img.height > maxHeight) {
              this.photoValidationError = `Image resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
              this.guardianDetails.guardian2.photo = null;
            } else {
              this.previewguardian2Photo = e.target.result;
              this.guardianDetails.guardian2.photo = file;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      validateSignature(file) {
        this.signatureValidationError = '';
        this.previewSignature = '';
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSize = 500 * 1024;
        const maxWidth = 350;
        const maxHeight = 450;

        if (!allowedTypes.includes(file.type)) {
          this.signatureValidationError = 'Only JPG and PNG formats are allowed.';
          this.guardianDetails.guardian1.signature = null;
          return;
        }
        if (file.size > maxSize) {
          this.signatureValidationError = 'File size should be 500KB or less.';
          this.guardianDetails.guardian1.signature = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > maxWidth || img.height > maxHeight) {
              this.signatureValidationError = `Signature resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
              this.guardianDetails.guardian1.signature = null;
            } else {
              this.previewSignature = e.target.result;
              this.guardianDetails.guardian1.signature = file;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      validateSignature2(file) {
        this.signatureValidationError2 = '';
        this.previewSignature2 = '';
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSize = 500 * 1024;
        const maxWidth = 350;
        const maxHeight = 450;

        if (!allowedTypes.includes(file.type)) {
          this.signatureValidationError2 = 'Only JPG and PNG formats are allowed.';
          this.guardianDetails.guardian2.signature = null;
          return;
        }
        if (file.size > maxSize) {
          this.signatureValidationError2 = 'File size should be 500KB or less.';
          this.guardianDetails.guardian2.signature = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > maxWidth || img.height > maxHeight) {
              this.signatureValidationError2 = `Signature resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
              this.guardianDetails.guardian2.signature = null;
            } else {
              this.previewSignature2 = e.target.result;
              this.guardianDetails.guardian2.signature = file;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      getChildDataForPhofile() {
        axios
          .post("/Parent/getChildGuardian", { learner: this.learner })
          .then((res) => {
            console.log("API Response:", res.data);
            if (res.data.flag === "YES") {
              // Set guardian details from backend response
              const guardianData = res.data.guardianDetails || {
                learner_id: "",
                registration_number: "",
                guardian1: { present: false, fields: [], photo: null, signature: null, old_photo: null, old_signature: null },
                guardian2: { present: false, fields: [], photo: null, signature: null, old_photo: null, old_signature: null },
              };
              this.$set(this, "guardianDetails", {
                learner_id: guardianData.learner_id || "",
                registration_number: guardianData.registration_number || "",
                guardian1: {
                  present: guardianData.guardian1 ? guardianData.guardian1.present : false,
                  fields: guardianData.guardian1 && guardianData.guardian1.fields ? guardianData.guardian1.fields.map((field) => {
                    if (!field) return { field_name: "", label: "", value: "", isactive: false, required: false, input_type: "text" };
                    return {
                      ...field,
                      value: field.multiple ? (field.value ? field.value.split(',') : []) : field.value || "",
                      isactive: field.isactive || false,
                      iseditable: field.iseditable || false,
                      required: field.required || false,
                      input_type: field.input_type || "text",
                    };
                  }) : [],
                  photo: null,
                  signature: null,
                  old_photo: (guardianData.guardian1 && guardianData.guardian1.fields.find((f) => f.field_name === "guardian1_photo")) ? guardianData.guardian1.fields.find((f) => f.field_name === "guardian1_photo").value : null,
                  old_signature: (guardianData.guardian1 && guardianData.guardian1.fields.find((f) => f.field_name === "guardian1_signature")) ? guardianData.guardian1.fields.find((f) => f.field_name === "guardian1_signature").value : null,
                },
                guardian2: {
                  present: guardianData.guardian2 ? guardianData.guardian2.present : false,
                  fields: guardianData.guardian2 && guardianData.guardian2.fields ? guardianData.guardian2.fields.map((field) => {
                    if (!field) return { field_name: "", label: "", value: "", isactive: false, required: false, input_type: "text" };
                    return {
                      ...field,
                      value: field.multiple ? (field.value ? field.value.split(',') : []) : field.value || "",
                      isactive: field.isactive || false,
                      iseditable: field.iseditable || false,
                      required: field.required || false,
                      input_type: field.input_type || "text",
                    };
                  }) : [],
                  photo: null,
                  signature: null,
                  old_photo: (guardianData.guardian2 && guardianData.guardian2.fields.find((f) => f.field_name === "guardian2_photo")) ? guardianData.guardian2.fields.find((f) => f.field_name === "guardian2_photo").value : null,
                  old_signature: (guardianData.guardian2 && guardianData.guardian2.fields.find((f) => f.field_name === "guardian2_signature")) ? guardianData.guardian2.fields.find((f) => f.field_name === "guardian2_signature").value : null,
                },
              });
              // Set emergency contact details directly from backend response
              const emergencyData = res.data.emergencyContactDetails || { present: false, fields: [] };
              this.$set(this, "emergencyContactDetails", {
                present: emergencyData.present || false,
                fields: emergencyData.fields || []
              });
            } else {
              this.showSnackbar("error", res.data.snackbar);
            }
          })
          .catch((error) => {
            console.error("Error fetching guardian data:", error);
            this.showSnackbar("error", "Failed to fetch guardian data.");
          });
      },
      SaveGuardiandata(type) {
        this.resetLoaders();
        let fieldsToSave = [];
        let photoField = null;
        let signatureField = null;
        let isPhotoUpload = false;
        let isSignatureUpload = false;
        let guardianType = type.replace('_Photo', '').replace('_Signature', '');

        // Set appropriate loader and fields
        if (type === 'Guardian1') {
          this.save_loader_guardian1 = true;
          fieldsToSave = this.guardianDetails.guardian1.fields;
        } else if (type === 'Guardian1_Photo') {
          this.save_loader_guardian1_photo = true;
          fieldsToSave = this.guardianDetails.guardian1.fields;
          photoField = this.guardianDetails.guardian1.photo;
          isPhotoUpload = true;
        } else if (type === 'Guardian1_Signature') {
          this.save_loader_guardian1_signature = true;
          fieldsToSave = this.guardianDetails.guardian1.fields;
          signatureField = this.guardianDetails.guardian1.signature;
          isSignatureUpload = true;
        } else if (type === 'Guardian2') {
          this.save_loader_guardian2 = true;
          fieldsToSave = this.guardianDetails.guardian2.fields;
        } else if (type === 'Guardian2_Photo') {
          this.save_loader_guardian2_photo = true;
          fieldsToSave = this.guardianDetails.guardian2.fields;
          photoField = this.guardianDetails.guardian2.photo;
          isPhotoUpload = true;
        } else if (type === 'Guardian2_Signature') {
          this.save_loader_guardian2_signature = true;
          fieldsToSave = this.guardianDetails.guardian2.fields;
          signatureField = this.guardianDetails.guardian2.signature;
          isSignatureUpload = true;
        }

        // Validate required fields
        if (!isPhotoUpload && !isSignatureUpload) {
          for (let field of fieldsToSave) {
            if (field.required && field.input_type !== 'file') {
              field.value = field.value ? String(field.value).trim() : '';
              if (!field.value) {
                const action = field.input_type === 'select' ? 'select' : 'enter';
                this.showSnackbar("error", `Please ${action} ${field.label}`);
                this.resetLoaders();
                return;
              }
            }
            if (field.field_name.includes('aadhar_no') && field.value) {
              if (field.value.toString().length !== 12) {
                this.showSnackbar("error", `${field.label} must be exactly 12 digits`);
                this.resetLoaders();
                return;
              }
            }
            if ((field.field_name.includes('contact') || field.field_name.includes('office_no')) && field.value) {
              if (field.value.toString().length !== 10) {
                this.showSnackbar("error", `${field.label} must be exactly 10 digits`);
                this.resetLoaders();
                return;
              }
            }
            if (field.field_name.includes('email') && field.value) {
              if (!/.+@.+\..+/.test(field.value)) {
                this.showSnackbar("error", `Please enter a valid ${field.label}`);
                this.resetLoaders();
                return;
              }
            }
          }
        }

        // Validate photo
        const photoFieldConfig = fieldsToSave.find(f => f.field_name === `${guardianType.toLowerCase()}_photo`);
        if (isPhotoUpload && photoFieldConfig && photoFieldConfig.required && !photoField) {
          this.showSnackbar("error", `Please select a photo for ${guardianType}`);
          this.resetLoaders();
          return;
        }
        if (isPhotoUpload && this.photoValidationError) {
          this.showSnackbar("error", this.photoValidationError);
          this.resetLoaders();
          return;
        }

        // Validate signature
        const signatureFieldConfig = fieldsToSave.find(f => f.field_name === `${guardianType.toLowerCase()}_signature`);
        if (isSignatureUpload && signatureFieldConfig && signatureFieldConfig.required && !signatureField) {
          this.showSnackbar("error", `Please select a signature for ${guardianType}`);
          this.resetLoaders();
          return;
        }
        if (isSignatureUpload && (guardianType === 'Guardian1' && this.signatureValidationError || guardianType === 'Guardian2' && this.signatureValidationError2)) {
          this.showSnackbar("error", guardianType === 'Guardian1' ? this.signatureValidationError : this.signatureValidationError2);
          this.resetLoaders();
          return;
        }

        // Prepare FormData
        let formData = new FormData();
        formData.append('learner_id', this.guardianDetails.learner_id);

        // Append all guardian fields
        this.guardianDetails.guardian1.fields.forEach(field => {
          if (field.input_type !== 'file') {
            formData.append(field.field_name, field.value ? String(field.value).trim() : '');
          }
        });
        this.guardianDetails.guardian2.fields.forEach(field => {
          if (field.input_type !== 'file') {
            formData.append(field.field_name, field.value ? String(field.value).trim() : '');
          }
        });

        // Append photo or signature if uploading
        // if (isPhotoUpload && photoField) {
        //   formData.append(`${guardianType.toLowerCase()}_photo`, photoField);
        // }
        // if (isSignatureUpload && signatureField) {
        //   formData.append(`${guardianType.toLowerCase()}_signature`, signatureField);
        // }
        if (isPhotoUpload && photoField) {
          formData.append(guardianType === 'Guardian1' ? 'photo1' : 'photo2', photoField);
        }
        if (isSignatureUpload && signatureField) {
          formData.append(guardianType === 'Guardian1' ? 'signature1' : 'signature2', signatureField);
        }
        axios.post("/Parent/saveGuardianData", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        }).then((res) => {
          this.resetLoaders();
          if (res.data.flag === "YES") {
            // Verify file fields if uploading photo or signature
            if (isPhotoUpload) {
              const photoField = res.data.guardianDetails[guardianType.toLowerCase()].fields.find(f => f.field_name === `${guardianType.toLowerCase()}_photo`);
              if (!photoField || !photoField.value) {
                this.showSnackbar("error", `Failed to save ${guardianType} Photo.`);
                return;
              }
            }
            if (isSignatureUpload) {
              const signatureField = res.data.guardianDetails[guardianType.toLowerCase()].fields.find(f => f.field_name === `${guardianType.toLowerCase()}_signature`);
              if (!signatureField || !signatureField.value) {
                this.showSnackbar("error", `Failed to save ${guardianType} Signature.`);
                return;
              }
            }
            this.showSnackbar("success", res.data.snackbar);
            // Update old photo/signature and reset inputs
            if (isPhotoUpload) {
              if (guardianType === 'Guardian1') {
                this.$set(this.guardianDetails.guardian1, 'old_photo',
                  res.data.guardianDetails.guardian1.fields.find(f => f.field_name === 'guardian1_photo').value || null);
                this.$set(this.guardianDetails.guardian1, 'photo', null);
                this.previewguardian1Photo = '';
              } else {
                this.$set(this.guardianDetails.guardian2, 'old_photo',
                  res.data.guardianDetails.guardian2.fields.find(f => f.field_name === 'guardian2_photo').value || null);
                this.$set(this.guardianDetails.guardian2, 'photo', null);
                this.previewguardian2Photo = '';
              }
            }
            if (isSignatureUpload) {
              if (guardianType === 'Guardian1') {
                this.$set(this.guardianDetails.guardian1, 'old_signature',
                  res.data.guardianDetails.guardian1.fields.find(f => f.field_name === 'guardian1_signature').value || null);
                this.$set(this.guardianDetails.guardian1, 'signature', null);
                this.previewSignature = '';
              } else {
                this.$set(this.guardianDetails.guardian2, 'old_signature',
                  res.data.guardianDetails.guardian2.fields.find(f => f.field_name === 'guardian2_signature').value || null);
                this.$set(this.guardianDetails.guardian2, 'signature', null);
                this.previewSignature2 = '';
              }
            }
            this.getChildDataForPhofile();
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        }).catch((err) => {
          this.resetLoaders();
          console.error(err);
          this.showSnackbar("error", "Failed to save guardian data.");
        });
      },
      saveEmergencyContactData() {
        this.resetLoaders();
        this.save_loader_emergency = true;

        // Validate required fields
        for (let field of this.emergencyContactDetails.fields) {
          if (field.required && field.input_type !== 'file') {
            field.value = field.value ? String(field.value).trim() : '';
            if (!field.value) {
              const action = field.input_type === 'select' ? 'select' : 'enter';
              this.showSnackbar("error", `Please ${action} ${field.label}`);
              this.save_loader_emergency = false;
              return;
            }
          }
          if (field.field_name === 'emergency_contact_name' && field.value) {
            if (!/^[a-zA-Z\s]*$/.test(field.value)) {
              this.showSnackbar("error", `${field.label} must contain only letters and spaces`);
              this.save_loader_emergency = false;
              return;
            }
          }
          if (field.field_name.includes('emergency_contact_number') && field.value) {
            if (field.value.toString().length !== 10) {
              this.showSnackbar("error", `${field.label} must be exactly 10 digits`);
              this.save_loader_emergency = false;
              return;
            }
          }
          if (field.field_name.includes('emergency_email') && field.value) {
            if (!/.+@.+\..+/.test(field.value)) {
              this.showSnackbar("error", `Please enter a valid ${field.label}`);
              this.save_loader_emergency = false;
              return;
            }
          }
        }
        let formData = new FormData();
        formData.append('learner_id', this.learner);

        this.emergencyContactDetails.fields.forEach(field => {
          if (field.input_type !== 'file') {
            formData.append(field.field_name, field.value ? String(field.value).trim() : '');
          }
        });

        axios.post("/Parent/saveEmergencyContactDetails", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        }).then((res) => {
          this.resetLoaders();
          if (res.data.flag === "YES") {
            this.showSnackbar("success", res.data.snackbar);
            this.emergencyContactDetails.emergency_contact_name = res.data.emergencyContactDetails.emergency_contact_name || "";
            this.emergencyContactDetails.emergency_contact_number = res.data.emergencyContactDetails.emergency_contact_number || "";
            this.emergencyContactDetails.emergency_relation = res.data.emergencyContactDetails.emergency_relation || "";
            this.emergencyContactDetails.emergency_contact_address = res.data.emergencyContactDetails.emergency_contact_address || "";
            this.emergencyContactDetails.emergency_email = res.data.emergencyContactDetails.emergency_email || "";
            this.emergencyContactDetails.fields.forEach(field => {
              field.value = res.data.emergencyContactDetails[field.field_name.replace('stud_', '')] || "";
            });
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        }).catch((err) => {
          this.resetLoaders();
          console.error(err);
          this.showSnackbar("error", "Failed to save emergency contact data.");
        });
      },
    }
  };
</script>

<style scoped>
  /* Existing styles remain unchanged */
  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }

  .main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .custom-tabs {
    background: linear-gradient(to right, #b2d8f7, #f4d1f4);
    border-radius: 30px;
    padding: 2px;
    min-height: 50px;
  }

  .custom-tab {
    font-weight: normal;
    color: black;
    text-transform: uppercase;
    font-size: 14px;
    min-height: 40px;
    border-radius: 0;
  }

  .first-tab {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .active-tab {
    background: white !important;
    color: black !important;
    font-weight: bold !important;
  }

  .button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
  }

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, .32);
    content: "";
  }

  .button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: .24;
  }
</style>